// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QDlRJ","fullView":"styles_fullView__2ZCFJ"};